const coreWalletStatusForSelection = ['Created', 'Active', 'Locked', 'Terminated'].map(key => {
	return { id: key, name: key };
});
const coreWalletTypesForSelection = ['Full', 'Guest'].map(key => {
	return { id: key, name: key };
});
export { coreWalletStatusForSelection, coreWalletTypesForSelection };
